import styled from 'styled-components';
import { Row } from 'spw-shared/globalComponents';
import { Tab } from '@mui/material';
import { colors } from 'spw-theme';

type ColorDotProps = {
  color: string;
};
export const TabsRow = styled(Row)`
  && {
    margin-top: 25px;
  }
`;

export const OUTab = styled(Tab)`
  && {
    border: 1px solid ${colors.veryLightGray};
    line-height: 1;
    height: 48px;
    border-radius: 4px;
    padding: 0px 12px;
    margin-right: 8px;

    &.Mui-selected {
      background: ${colors.brightGray};
    }
  }
`;

export const ColorDot = styled('div')<ColorDotProps>`
  background: ${({ color }) => color};
  width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CategoryDotWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const PopoverContainer = styled.div`
  width: 180px;
`;

export const DownloadNameCardContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 24px;
`;
export const DownloadOption = styled.div`
  padding: 8px 16px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;
